module.exports = __webpack_public_path__ + "static/media/red-bg-portrait.1f785328.webp";